var _defs, _rect, _rect2, _text, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 64",
    role: "img",
    "aria-label": "GrowOne India logo white version for dark backgrounds",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GrowOne India \u2013 White Version") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teal1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a9e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f7a6e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#teal1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 46,
    height: 46,
    rx: 6,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 11,
    y: 47,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontWeight: 700,
    fontSize: 34,
    fill: "white"
  }, "G")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 47,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontWeight: 700,
    fontSize: 34,
    fill: "white"
  }, "I")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 28,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontWeight: 700,
    fontSize: 20,
    fill: "#ffffff"
  }, "GrowOne India")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 59,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 8.5,
    fontWeight: 400,
    fill: "rgba(255,255,255,0.45)",
    letterSpacing: 1.2
  }, "EST. 2020 \xB7 PUNE, MAHARASHTRA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b41d6d9ab05abff4371250284b4190da.svg";
export { ForwardRef as ReactComponent };